import { cache } from 'react';
import { getPageContentByDeliveryKey } from '@api/getPageContent';
import { getDefaultGeo } from '@utils/server/getGeoFromPath';

const getContent = cache(async (locale: string) => {
  const response = await getPageContentByDeliveryKey(`www-site-content-${locale.toLowerCase()}`);
  if (!response?.body && Object.keys(response.body).length) {
    return getPageContentByDeliveryKey(`www-site-content-${getDefaultGeo().locale.toLowerCase()}`);
  }
  return response;
});
export const getTranslations = async (locale: string) => {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    body: { _meta: _, ...content },
  } = await getContent(locale);

  return content;
};
